import { useRouter } from 'next/router';
import React, { ReactElement, useEffect } from 'react';

type Props = {

};

const ScrollToTop : React.FC<Props> = () : ReactElement => {
    const router = useRouter();

    useEffect(() => {
        // "document.documentElement.scrollTo" is the magic for React Router Dom v6
        document.documentElement.scrollTo({
            top: 0,
            left: 0,
            // @ts-ignore
            behavior: 'instant', // Optional if you want to skip the scrolling animation
        });
    }, [router.pathname]);

    return <></>;
};

export default ScrollToTop;
